import dayjs from "dayjs";
import AwsServerService from "../common/util/AwsServerService"
import _ from "lodash";
import { PushInputFieldValidation, RemoveInputFieldValidation } from "../Context/ReduxContext";


export const fetchCriteriaFields = () => {
  new Promise(async (resolve, reject) => {
    await AwsServerService.getCriteriaFields().then(res => {
      // console.log("api data===", res.dada[0]);
      resolve(res.data);
    }).catch(err => {
      reject(err);
    })
  })
}
export const getCriteriaFieldsAndObjects = async (allDeals, allTasks) => {
  return new Promise((resolve, reject) => {
    let obj = {
      "Deal_Name": _.uniqBy(allDeals, 'Deal_Name')?.map(deal => ({ label: deal.Deal_Name, value: deal.Deal_Name })),
      "City": _.uniqBy(allDeals, 'City')?.map(deal => ({ label: deal.City, value: deal.City })),
      "State": _.uniqBy(allDeals, 'State')?.map(deal => ({ label: deal.State, value: deal.State })),
      "TaskName": _.uniqBy(allTasks, 'TaskName')?.map(task => ({ label: task.TaskName, value: task.TaskName })),
      "Assignee": _.uniqBy(allTasks, 'Assignee')?.map(task => ({ label: task.Assignee, value: task.Assignee })),
      "Supervisor": _.uniqBy(allTasks, 'Supervisor')?.map(task => ({ label: task.Supervisor, value: task.Supervisor })),
    };
    // console.log("------------criteria multi",obj);
    resolve(obj);
  })
}
export function evaluateEdgeVisibility(dataObject, edge, allEdges, AppReduxContextDispatch) {
  if (!edge?.Criteria?.length) return true;
  const safeIncludes = (value, target) => {
    try {
      return value?.includes?.(target);
    } catch {
      return false;
    }
  };

  const safeCompareDate = (v, l, fn) => {
    try {
      return dayjs(v)[fn]?.(dayjs(l));
    } catch {
      return false;
    }
  };

  const evaluateCriterion = (criterion) => {
    const { group, initial, middel, last, type } = criterion ?? {};
    if (!group) return false;
    if ((group === "Transition" || group==='Transitions') && initial && middel && last) {
      const targetEdge = allEdges?.find(e => e?.id === initial);
      if (!targetEdge) return true;

      if (middel === "Is") return last === "Required" ? !!targetEdge.data?.visited : true;
      if (middel === "Is Not") return last === "Not Required" ? !!targetEdge.data?.visited : true;
      return true;
    }
    

    const groupData = dataObject?.[group];
    if (!groupData || !initial || !middel) return false;

    const keyToCompare = initial == "TaskStatus"? "TaskStatusText": initial;

    let valueToCompare = group === "Input Fields"
      ? groupData?.find(k => k?.id === keyToCompare)?.value
      : initial == "TaskStatus"?groupData?.[keyToCompare]?.toLowerCase()?.replace(/\b(\w+)\b/g, (match) => match.charAt(0).toUpperCase() + match.slice(1)):groupData?.[keyToCompare];

    if (initial === 'Account_Name') valueToCompare = _.isObject(valueToCompare)?valueToCompare?.name:valueToCompare;
    if (valueToCompare === undefined || valueToCompare === null) return false;
    if(initial === 'TaskStatus' && !Array.isArray(valueToCompare)) {
      valueToCompare = [valueToCompare]
    }
    if(initial === 'PipelineName' && !Array.isArray(valueToCompare)) {
      valueToCompare = [valueToCompare]
    }
    if(initial === 'TaskFlowObject' && !Array.isArray(valueToCompare)) {
      valueToCompare = [valueToCompare.Name]
    }
    if((initial === 'StartDate' || initial === 'DueDate' || initial === 'CREATEDTIME')  && !Array.isArray(valueToCompare)){
      let onlyDate = initial === 'CREATEDTIME' ? valueToCompare.split(" ")[0] : valueToCompare.split("T")[0];
      valueToCompare = onlyDate
    }
    if(initial === "IsMilestone"){
      valueToCompare = valueToCompare == 1 ? true : false;
    }
    let criterionResult = false;

    try {
      switch (type) {
        case "TEXT":
        case "PHONE":
        case "DEFAULT":
          switch (middel) {
            case "Is": criterionResult = valueToCompare == last; break;
            case "Is Not": criterionResult = valueToCompare !== last; break;
            case "Contains": criterionResult = safeIncludes(valueToCompare, last); break;
            case "Not Contains": criterionResult = !safeIncludes(valueToCompare, last); break;
            case "Starts With": criterionResult = valueToCompare?.toLowerCase?.().startsWith(last?.toLowerCase?.()); break;
            case "Ends With": criterionResult = valueToCompare?.toLowerCase?.().endsWith(last?.toLowerCase?.()); break;
            case "Is Empty": criterionResult = !valueToCompare; break;
            case "Is Not Empty": criterionResult = !!valueToCompare; break;
          }
          break;

        case "NUMBER":
        case "CURRENCY":
          const numVal = Number(valueToCompare);
          const numLast = Number(last);
          switch (middel) {
            case "=": criterionResult = numVal == numLast; break;
            case "!=": criterionResult = numVal !== numLast; break;
            case "<": criterionResult = numVal < numLast; break;
            case "<=": criterionResult = numVal <= numLast; break;
            case ">": criterionResult = numVal > numLast; break;
            case ">=": criterionResult = numVal >= numLast; break;
          }
          break;

        case "DATE":
          switch (middel) {
            case "Is": criterionResult = safeCompareDate(valueToCompare, last, 'isSame'); break;
            case "Is Not": criterionResult = !safeCompareDate(valueToCompare, last, 'isSame'); break;
            case "Before": criterionResult = safeCompareDate(valueToCompare, last, 'isBefore'); break;
            case "After": criterionResult = safeCompareDate(valueToCompare, last, 'isAfter'); break;
            case "Between": 
              const start = new Date(last.startDate);
              const end = new Date(last.endDate);
              const target = new Date(valueToCompare);
              criterionResult = target >= start && target <= end;
              break;
          }
          break;

        case "PICKLIST":
        case "USER":
          switch (middel) {
            case "Is": criterionResult = valueToCompare == last; break;
            case "Is Not": criterionResult = valueToCompare !== last; break;
            case "Is Empty": criterionResult = !valueToCompare; break;
            case "Is Not Empty": criterionResult = !!valueToCompare; break;
            case "Any Of": criterionResult = Array.isArray(valueToCompare)
              ? last?.some(v => valueToCompare.includes(v))
              : last?.includes?.(valueToCompare); break;
            case "All Of": criterionResult = Array.isArray(valueToCompare) && last?.every?.(v => valueToCompare.includes(v)); break;
            case "None Of": criterionResult = Array.isArray(valueToCompare) && !last?.some?.(v => valueToCompare.includes(v)); break;
          }
          break;

        case "MULTI-PICKLIST":
          switch (middel) {
            case "Any Of": criterionResult = valueToCompare?.some?.(v => last?.includes(v)); break;
            case "All Of": criterionResult = last?.every?.(v => valueToCompare?.includes(v)); break;
            case "None Of": criterionResult = !last?.some?.(v => valueToCompare?.includes(v)); break;
            case "Is Empty": criterionResult = !valueToCompare?.length; break;
            case "Is Not Empty": criterionResult = !!valueToCompare?.length; break;
          }
          break;

        case "CHECKBOX":
          criterionResult = middel === "Is" ? valueToCompare == last : valueToCompare != last;
          break;

        case "ATTACHMENT":
          criterionResult = last === "Required"
            ? !!valueToCompare?.name
            : true;
          break;

        case "BOOLEAN":
          switch (middel) {
            case "Is": criterionResult = valueToCompare === (last === true || last === false || last === 0 || last === 1 ); break;
            case "Is Not": criterionResult = valueToCompare !== (last === true || last === false || last === 0 || last === 1 ); break;
          }
          break;

        default:
          criterionResult = false;
      }
    } catch (err) {
      console.error("Error evaluating criterion:", err);
    }

    // Push/remove validation state safely
    try {
     if (criterionResult) {
          if (AppReduxContextDispatch) {
            AppReduxContextDispatch(RemoveInputFieldValidation(initial));
          } else {
            // console.warn('AppReduxContextDispatch not provided, skipping RemoveInputFieldValidation.');
          }
        } else {
          if (AppReduxContextDispatch) {
            AppReduxContextDispatch(PushInputFieldValidation(initial));
          } else {
            // console.warn('AppReduxContextDispatch not provided, skipping PushInputFieldValidation.');
          }
        } 
    } catch (err) {
      console.warn("Redux dispatch failed:", err);
    }

    return criterionResult;
  };

  const evaluateGroup = (groupArray = []) => {
    return groupArray.reduce((result, item, index) => {
      const hasSubGroup = Array.isArray(item?.Group);
      const hasData = item?.group && item?.initial && item?.middel && item?.last;

      let itemResult;
      if (hasSubGroup && hasData) {
        itemResult = evaluateCriterion(item) && evaluateGroup(item.Group);
      } else if (hasSubGroup) {
        itemResult = evaluateGroup(item.Group);
      } else {
        itemResult = evaluateCriterion(item);
      }

      if (index === 0) return itemResult;
      if (item.condition === "AND") return result && itemResult;
      if (item.condition === "OR") return result || itemResult;

      console.warn(`Unknown condition: ${item.condition}`);
      return false;
    }, true);
  };

  return evaluateGroup(edge?.Criteria);
}

export function evaluateEdgeVisibilityDashboard(dataObject, edge ,allEdges, AppReduxContextDispatch) {
  
  if (!edge.Criteria || edge.Criteria.length === 0) {
    // If no criteria, the edge is visible by default
    return true;
  }

  // Initialize result based on first criterion (before applying conditions)
  let overallResult = true; // Start with true (for AND logic)

  // Loop through each criterion for the edge
  for (let i = 0; i < edge.Criteria.length; i++) {
    
    const criterion = edge.Criteria[i];
    const { group, initial, middel, last, condition, type} = criterion;

    // Extract the relevant data from the provided dataObject
    if (group == "Transition") {
      if (initial && middel && last) {
        const edge = allEdges?.find(ee=>ee.id==initial); 
        let criterionResult = false; 

        switch (middel) {
          case "Is":
            switch (last) {
              case "Required":
                criterionResult = edge.visited?true:false;
                break;
              case "Not Required":
                criterionResult = true;
                break;
              default:
                console.warn(`Unknown operator: ${last}`);
                criterionResult = false; 
            }
            break;
          case "Is Not":
            switch (last) {
              case "Required":
                criterionResult = true;
                break;
              case "Not Required":
                criterionResult = edge.visited?true:false;
                break;
              default:
                console.warn(`Unknown operator: ${last}`);
                criterionResult = false; 
            }
            break;
          default:
            console.warn(`Unknown operator: ${middel}`);
            criterionResult = false; // If the operator is unknown, treat it as false
        }
        // Apply the logical condition (AND/OR)
        if (i === 0) {
          // For the first criterion, no condition, just take the result
          overallResult = criterionResult;
        } else if (condition === "AND") {
          // Apply AND condition
          overallResult = overallResult && criterionResult;
        } else if (condition === "OR") {
          // Apply OR condition
          overallResult = overallResult || criterionResult;
        } else {
          console.warn(`Unknown condition: ${condition}`);
          return false; // Hide edge if the condition is unknown
        }
      }
    }else{
      let groupData;
      groupData = dataObject[group]; 
      if (initial && middel && last) {
        if (!groupData) {
          overallResult = false; 
        } else {
          let valueToCompare; 
          if(group=="Input Fields" && initial){
            valueToCompare = groupData?.find(k=>k.id==initial)?.value; 
          }else{
            valueToCompare = groupData[initial]; 
          }
          let criterionResult = false; // Store individual criterion result

          if(["TEXT","PHONE","DEFAULT"].includes(type)){
            // Evaluate based on the operator (middel)
            switch (middel) {
              case "Is":
                criterionResult = valueToCompare === last;
                break;
              case "Is Not":
                criterionResult = valueToCompare !== last;
                break;
              case "Contains":
                criterionResult = typeof valueToCompare === "string" && valueToCompare.includes(last);
                break;
              case "Not Contains":
                criterionResult = typeof valueToCompare === "string" && !valueToCompare.includes(last);
                break;
              case "Starts With":
                criterionResult = typeof valueToCompare === "string" && valueToCompare.toLowerCase().startsWith(last.toLowerCase());
                break;
              case "Ends With":
                criterionResult = typeof valueToCompare === "string" && valueToCompare.toLowerCase().endsWith(last.toLowerCase());
                break;
              case "Is Empty":
                criterionResult =  valueToCompare === "" || valueToCompare === undefined || valueToCompare === null;
                break;
              case "Is Not Empty":
                criterionResult =  valueToCompare !== "" && valueToCompare !== undefined && valueToCompare !== null;
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }else if(["NUMBER","CURRENCY"].includes(type)){
            switch (middel) {
              case "=":
                criterionResult = valueToCompare === last;
                break;
              case "!=":
                criterionResult = valueToCompare !== last;
                break;
              case "<":
                criterionResult = typeof valueToCompare === "number" && valueToCompare<last;
                break;
              case "<=":
                criterionResult = typeof valueToCompare === "number" && valueToCompare<=last;
                break;
              case ">":
                criterionResult = typeof valueToCompare === "number" && valueToCompare>last;
                break;
              case ">=":
                criterionResult = typeof valueToCompare === "number" && valueToCompare>=last;
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }else if(["DATE"].includes(type)){
            switch (middel) {
              case "Is":
                criterionResult = dayjs(valueToCompare).format("MM/DD/YYYY") === dayjs(last).format("MM/DD/YYYY");
                break;
              case "Is Not":
                criterionResult = dayjs(valueToCompare).format("MM/DD/YYYY") !== dayjs(last).format("MM/DD/YYYY");
                break;
              case "Before":
                criterionResult = dayjs(valueToCompare).isBefore(last);
                break;
              case "After":
                criterionResult = dayjs(valueToCompare).isAfter(last);
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }else if(["PICKLIST"].includes(type)){
            switch (middel) {
              case "Is":
                criterionResult = valueToCompare === last;
                break;
              case "Is Not":
                criterionResult = valueToCompare !== last;
                break;
              case "Is Empty":
                criterionResult = valueToCompare === undefined || valueToCompare === null || valueToCompare=="";
                break;
              case "Is Not Empty":
                criterionResult = valueToCompare != undefined && valueToCompare != null && valueToCompare!="";
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }else if(["MULTI-PICKLIST"].includes(type)){
            // if(valueToCompare && !Array.isArray(valueToCompare)){
            //   valueToCompare = [valueToCompare];
            // }
            switch (middel) {
              case "Any Of":
                criterionResult = Array.isArray(valueToCompare) && valueToCompare?.some(v1=>last.includes(v1));
                break;
              case "All Of":
                  
                criterionResult = (Array.isArray(valueToCompare) && !last?.some(v1=>!valueToCompare.includes(v1)));
                break;
              case "None Of":
                criterionResult = !(Array.isArray(valueToCompare) && last?.some(v1 => valueToCompare.includes(v1)));
                break;
              case "Is Empty":
                criterionResult = valueToCompare === undefined || valueToCompare === null || valueToCompare?.length==0;
                break;
              case "Is Not Empty":
                criterionResult = valueToCompare != undefined && valueToCompare != null && valueToCompare?.length>0;
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }
          else if(["CHECKBOX"].includes(type)){
            switch (middel) {
              case "Is":
                criterionResult = valueToCompare==last;
                break;
              case "Is Not":
                criterionResult = valueToCompare!=last;
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }
          else if(["ATTACHMENT"].includes(type)){
            switch (middel) {
              case "Is":
                
                criterionResult = last=="Required"? (valueToCompare && valueToCompare?.name?true:false): true ;
                break;
              case "Is Not":
                criterionResult = last=="Not Required"? (valueToCompare && valueToCompare?.name?true:false): true;
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }
          else if(["USER"].includes(type)){
            // if(valueToCompare && !Array.isArray(valueToCompare)){
            //   valueToCompare = [valueToCompare];
            // }
            switch (middel) {
              case "Any Of":
                 
                criterionResult = Array.isArray(valueToCompare) && valueToCompare?.some(v1=>last.includes(v1));
                break;
              case "All Of":
                  
                criterionResult = (Array.isArray(valueToCompare) && !last?.some(v1=>!valueToCompare.includes(v1)));
                break;
              case "None Of":
                criterionResult = !(Array.isArray(valueToCompare) && last?.some(v1 => valueToCompare.includes(v1)));
                break;
              case "Is Empty":
                criterionResult = valueToCompare === undefined || valueToCompare === null || valueToCompare?.length==0;
                break;
              case "Is Not Empty":
                criterionResult = valueToCompare != undefined && valueToCompare != null && valueToCompare?.length>0;
                break;
              default:
                console.warn(`Unknown operator: ${middel}`);
                criterionResult = false; // If the operator is unknown, treat it as false
            }
          }
          // validation state conditions
          if(criterionResult){
            AppReduxContextDispatch(RemoveInputFieldValidation(initial))
          }else{
            AppReduxContextDispatch(PushInputFieldValidation(initial))

          }
          //end
          // Apply the logical condition (AND/OR)
          if (i === 0) {
            // For the first criterion, no condition, just take the result
            overallResult = criterionResult;
          } else if (condition === "AND") {
            // Apply AND condition
            overallResult = overallResult && criterionResult;
          } else if (condition === "OR") {
            // Apply OR condition
            overallResult = overallResult || criterionResult;
          } else {
            console.warn(`Unknown condition: ${condition}`);
            return false; // Hide edge if the condition is unknown
          }
        }
      }
    }
  }
  return overallResult; // Return the final visibility result
}

export function filterEdges(edges, edge) {
  // Extract the source of the provided edge
  const edgeSource = edge.source;
  const edgeTarget = edge.target;

  // Filter the edges array
  const filteredEdges = edges.filter(e => {
    // Check if the edge's destination matches the provided edge's source
    const isMatchingDestination = e.target === edgeSource;

    // Exclude circular connections where source and target are reversed
    const isCircularConnection = e.source === edgeTarget && e.target === edgeSource;

    // Return only edges that match the destination and are not circular
    return isMatchingDestination && !isCircularConnection;
  });

  return filteredEdges;
}
